import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './alarmList.css';
import '../../App.css';
import config from '../../config';
import { ko } from 'date-fns/locale';
import { CSVLink } from 'react-csv';



function AlarmList() {
  const [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate() - 3)));
  const [endDate, setEndDate] = useState(new Date());
  const [alarmData, setAlarmData] = useState([]);
  const [csvData, setCsvData] = useState([]);  // CSV 데이터 저장

  const handleSearch = async () => {
    try {
      // KST 기준 날짜 문자열로 변환 (UTC ISO 사용 시 날짜가 하루 어긋날 수 있음)
      const localStart = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[0];
      const localEnd = new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[0];

      const response = await fetch(`${config.backendUrl}/get_Error_History_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          startDate: localStart,
          endDate: localEnd,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // 데이터를 최신순으로 정렬
        const sortedData = {
          ...data,
          data: data.data.sort((a, b) => new Date(b.time) - new Date(a.time))
        };
        setAlarmData(sortedData);
        // CSV 데이터 형식 변환
        const csvFormattedData = sortedData.data.map((item, index) => ({
          번호: index + 1,
          발생일시: item.time,
          경보메세지: item.Message
        }));
        setCsvData(csvFormattedData);
      }
    } catch (error) {
      console.error('데이터 조회 중 오류 발생:', error);
    }
  };

  return (
    <div className="alarm-container">
      <div className="search-controls">
        <div className="date-controls">
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={endDate}
            minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
            locale={ko}
            customInput={<input className="date-input" />}
          />
          <div>~</div>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
            maxDate={new Date()}
            minDate={startDate}
            locale={ko}
            customInput={<input className="date-input" />}
          />
        </div>

        <button onClick={handleSearch} className="search-button">검색</button>

        <CSVLink
          data={csvData}
          filename="alarm-data.csv"
          className="csv-download"
        >
          CSV 다운로드
        </CSVLink>
      </div>

      <div className="table-container">
        <table className="alarm-table">
          <thead>
            <tr className="table-header">
              <th className="table-cell">번호</th>
              <th className="table-cell">발생일시</th>
              <th className="table-cell">경보메세지</th>
            </tr>
          </thead>
          <tbody>
            {alarmData && alarmData.data && alarmData.data.length > 0 ? (
              alarmData.data.map((alarm, index) => (
                <tr key={alarm.id}>
                  <td className="table-cell">{index + 1}</td>
                  <td className="table-cell">{alarm.time}</td>
                  <td className="table-cell">{alarm.Message}</td>
                </tr>
              ))
            ) : (
              <tr className="no-data-row">
                <td colSpan="3" className="no-data table-cell">검색된 자료가 없습니다!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default AlarmList;